import React, { createContext, useReducer, useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import { useUpdatePlaylist } from '../hooks/preferencesHooks'
import { setPlaylistItemAsWatched } from '../api/preference/playlist'

export const PlaylistContext = createContext()

const initialState = {
  status: 'REQUEST_PLAYLIST',
  playlist: [],
  pending: false,
}

function stateReducer(state, { type, value }) {
  switch (type) {
    case 'REQUEST_PLAYLIST':
      return { ...state, status: 'REQUEST_PLAYLIST' }
    case 'PLAYLIST_REQUESTED':
      return { ...state, status: 'PLAYLIST_REQUESTED' }
    case 'PLAYLIST_LOADED':
      return { ...state, status: 'PLAYLIST_LOADED', playlist: value }
    case 'PLAYLIST_LOCALLY_REFRESHED':
      return { ...state, status: 'PLAYLIST_LOCALLY_REFRESHED', playlist: value }
    default:
      return { ...state, status: 'INITIAL' }
  }
}

export function PlaylistProvider({ children }) {
  const user = useUser()
  const [updatePlaylist, updateRequestState] = useUpdatePlaylist()
  const [state, dispatch] = useReducer(stateReducer, initialState)

  useEffect(() => {
    if (user?.cisId && state.status === 'REQUEST_PLAYLIST' && !updateRequestState.pending) {
      // debugger
      updatePlaylist({ method: 'GET' })
      dispatch({ type: 'PLAYLIST_REQUESTED' })
    }
  }, [updateRequestState.pending, state.status, updatePlaylist, user.cisId])

  useEffect(() => {
    if (!user?.signedIn && !user.userLoading) {
      dispatch({ type: 'PLAYLIST_LOADED' })
    }
  }, [user.signedIn, user.userLoading])

  useEffect(() => {
    if (updateRequestState.complete && !updateRequestState.pending) {
      dispatch({ type: 'PLAYLIST_LOADED', value: updateRequestState.response?.playlistItems ?? [] })
    }
  }, [updateRequestState.complete, updateRequestState.pending, updateRequestState.response])

  const removePlaylistItem = (playlistItem) => {
    return updatePlaylist({ playlistItem, method: 'DELETE' })
  }

  const addPlaylistItem = (playlistItem) => {
    return updatePlaylist({ playlistItem, method: 'PUT' })
  }

  const getPlaylistItem = (cmsId) => {
    let item = null

    if (state.playlist) {
      item = state.playlist.find((next) => next.cmsId === cmsId)
    }

    return item
  }

  const markPlaylistItemAsWatched = (cmsId) => {
    const item = getPlaylistItem(cmsId)
    if (item) {
      item.watched = true
      setPlaylistItemAsWatched(cmsId)
    }
  }

  const isPlaylistItemWatched = (cmsId) => {
    if (state.playlist) {
      const item = state.playlist.find((next) => next.cmsId === cmsId)
      if (item) {
        return item.watched
      }
    }

    return false
  }

  return (
    <PlaylistContext.Provider
      value={{
        ...state,
        updateRequestState,
        dispatch,
        addPlaylistItem,
        removePlaylistItem,
        markPlaylistItemAsWatched,
        isPlaylistItemWatched,
        getPlaylistItem,
      }}
    >
      {children}
    </PlaylistContext.Provider>
  )
}
